import React,{useEffect} from 'react'

import './Subscribe.scss'


const Subscribe = () => {

  useEffect(() => {
    window.scrollTo(0, 0);

}, [])

  return (

    <>

      <div className="boody">
        Stay up to speed on the latest at Flux.
      </div>
      <div className="main_subscribe">
        <div className="input_list">
          <div className="line">
            <span> Email </span>
            <input
              id="newsletterEmail"
              name="email"
              type="text"
              label="Email"
              placeholder="jsmith@example.com"
              autocomplete="off"
            />
          </div>
          <div className="agree">
            <input type="checkbox" /><span>Join our mailing list for early access to product announcements, special events in your area, promotions, and more.</span>
          </div>
          <div className="btn">
            <button>Subscribe</button>
          </div>
          <div className="copy">
            By submitting this form, you agree to our <span>Terms of Use</span> and our <span> Privacy Policy</span>.
          </div>
        </div>
      </div>

    </>

  )
}

export default Subscribe